import React from 'react'
import { BreadcrumbView } from '../../../../../../context/breadcrumb.context'
import { Card } from '../../../../../../shared/card/card'
import { Form, FormHiddenNumber, FormSubmit, FormText } from '../../../../../../shared/form/form'
import { useApiFormTemplate } from '../../../../../../api-new/state/content'
import { CardFullHeightScrollY } from '../../../../../../shared/card/card-full-height-scroll-y'
import { IconAdd } from '../../../../../../shared/icon/icon'
import { useHistory } from '../../../../../../../node_modules/react-router-dom/cjs/react-router-dom.min'
import { useDataContext } from '../data-context'

export const NodeTemplateAdd = ({ parentURL, parentID }) => {
  const history = useHistory()

  const dataContext = useDataContext()

  const apiFormTemplate = useApiFormTemplate()

  const handleSubmit = async data => {
    await apiFormTemplate.post(data)
    await dataContext.reload()
    history.push(parentURL)
  }

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconAdd} text="Add template">
        <CardFullHeightScrollY title="add template">
          <Card>
            <Form state={apiFormTemplate.form} onSubmit={handleSubmit}>
              <FormHiddenNumber name="parentID" value={parentID} />
              <FormText label="name" name="name" required />
              <FormSubmit text="create" />
            </Form>
          </Card>
        </CardFullHeightScrollY>
      </BreadcrumbView>
    </React.Fragment>
  )
}
